import { forwardRef } from 'react';
import { Tooltip } from '@optimus-web/core';

export const TooltippedSpan = Tooltip(
    forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>((props, ref) => <span {...props} ref={ref} />)
);
